// extracted by mini-css-extract-plugin
export default {"description":"description-read-only_description__LR-rx"};